import { Theme, alpha } from '@mui/material/styles';

/**
 * Shell chrome palette derived from the active theme
 * Replaces inline MainLayout `C` object with semantic naming
 */
export function shellPalette(theme: Theme) {
  const P = theme.palette;
  const isDark = theme.palette.mode === 'dark';
  
  return {
    navBg: P.background.paper,
    navBorder: P.divider,
    navHover: P.action.hover,
    navActive: alpha(P.primary.main, 0.12),
    navActiveBorder: P.primary.main,
    sectionLabel: P.text.disabled,
    navText: P.text.secondary,
    navTextActive: isDark ? P.primary.light : P.primary.dark,
    iconBg: alpha(P.primary.main, 0.12),
    iconColor: isDark ? P.primary.light : P.primary.dark,
    topBg: alpha(P.background.paper, 0.85),
    topBorder: P.divider,
    contentBg: P.background.default,
    countBg: P.action.hover,
    countText: P.text.disabled,
  };
}